import * as React from 'react';
import {IChannel} from '../../../../data/api/models';

interface IDeclinesAndReferralsProps {
  declines: IDeclineOrReferrralReason[];
  referrals: IDeclineOrReferrralReason[];
  errors: string[];
  quoteReference?: string;
  renewal: boolean;
  channel: IChannel;
}

interface IDeclineOrReferrralReason {
  name: string;
  reason: string;
  team_factor: any;
}

class DeclinesAndReferrals extends React.Component<IDeclinesAndReferralsProps> {
  public render() {
    const { declines, referrals, errors, quoteReference, renewal, channel } = this.props;

    if (! declines.length && ! referrals.length && ! errors.length) {
      return null;
    }

    return (
      <div>
        {declines.length > 0 && (
          <div className="alert alert-danger animated fadeIn">
            <p>Thank you for your enquiry. Unfortunately, due to your selection we are unable to provide you with a
              quotation at this time.</p>
          </div>

        )}

        {(declines.length === 0 && referrals.length > 0) && (
          <div className="alert alert-warning animated fadeIn">
            {renewal ? (
              <p>
                Thank you for your renewal enquiry. Due to your selection we require more information in order to
                provide you with a quotation please call {channel.baseName} on {channel.phone} who will be able to
                assist you.
              </p>
            ) : (
              <p>
                Thank you for your enquiry. Due to your selection we require more information in order to provide you
                with a quotation please call {channel.baseName} on {channel.phone} who will be able to assist you.
                <br/><br/>
                Your reference is <strong>{quoteReference}</strong>.
              </p>
            )}
          </div>
        )}

        {errors.length > 0 && (
          <div className="alert alert-danger animated fadeIn">
            <ul>
              {errors.map((error, index) => {
                return (
                  <li key={index}>{error}</li>
                );
              })}
            </ul>
          </div>
        )}

      </div>
    );
  }
}

export default DeclinesAndReferrals;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/components/DeclinesAndReferrals/index.tsx